import { get, put } from '../../api';

export const getVariaveisAmbiente = (idCliente) => {
  return get(`/api/indicadores/variaveis/ambiente/${idCliente}`);
};

export const getVariavelAmbiente = (idCliente, idInformacao) => {
  return get(`/api/indicadores/variavel/ambiente/${idCliente}/${idInformacao}`);
};

export const putVariavelAmbiente = (data) => {
  return put('/api/indicadores/variavel/ambiente', data);
};
